"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDnd = require("react-dnd");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _DragAndDrop = require("lead-flows-ui/constants/DragAndDrop");

var FormFieldDropTarget =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormFieldDropTarget, _Component);

  function FormFieldDropTarget() {
    (0, _classCallCheck2.default)(this, FormFieldDropTarget);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldDropTarget).apply(this, arguments));
  }

  (0, _createClass2.default)(FormFieldDropTarget, [{
    key: "isReadyForDrop",
    value: function isReadyForDrop() {
      var _this$props = this.props,
          hasDragOver = _this$props.hasDragOver,
          isDragSourceDroppable = _this$props.isDragSourceDroppable;
      return hasDragOver && isDragSourceDroppable;
    }
  }, {
    key: "render",
    value: function render() {
      var connectDropTarget = this.props.connectDropTarget;
      var hasDragOverClass = this.isReadyForDrop() ? 'has-drag-over' : null;
      var className = (0, _classNames.default)('form-field-drop-target', hasDragOverClass);
      return connectDropTarget(_react.default.createElement("div", {
        className: className
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        index: _react.PropTypes.number.isRequired,
        connectDropTarget: _react.PropTypes.func.isRequired,
        hasDragOver: _react.PropTypes.bool.isRequired,
        isDragSourceDroppable: _react.PropTypes.bool.isRequired,
        moveFormField: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return FormFieldDropTarget;
}(_react.Component);

var dragSpec = {
  canDrop: function canDrop(props, monitor) {
    var fieldOrder = monitor.getItem().displayOrder;
    var targetPosition = props.index;
    return (// Target isn't right above the field.
      fieldOrder !== targetPosition && // Target isn't right below the field.
      fieldOrder + 1 !== targetPosition
    );
  },
  drop: function drop(props, monitor, component) {
    if (monitor.didDrop()) {
      return;
    }

    var fieldName = monitor.getItem().name;
    var targetPosition = props.index;
    component.props.moveFormField(fieldName, targetPosition);
  }
};

function collect(connector, monitor) {
  return {
    connectDropTarget: connector.dropTarget(),
    hasDragOver: monitor.isOver(),
    isDragSourceDroppable: monitor.canDrop()
  };
}

var _default = (0, _reactDnd.DropTarget)(_DragAndDrop.DragTypes.FORM_FIELD, dragSpec, collect)(FormFieldDropTarget);

exports.default = _default;
module.exports = exports.default;